var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListingSettingsHeader", {
    attrs: {
      searchable: "",
      searchValue: _vm.searchValue,
      filters: _vm.filters,
      displayTotalResults: "",
      totalResults: _vm.totalResults
    },
    on: { search: _vm.searchAttributes, selectFilter: _vm.updateActiveFilters },
    scopedSlots: _vm._u([
      {
        key: "filters",
        fn: function() {
          return [
            _vm._l(_vm.getActiveFilters, function(activeFilter) {
              return [
                activeFilter.components === "ListingFiltersSelect"
                  ? _c("ListingFilterSelect", {
                      key: activeFilter.code,
                      attrs: { filter: activeFilter },
                      on: {
                        "update:displayDropdown": function(value) {
                          return _vm.displayDropdown(activeFilter, value)
                        },
                        updateFilter: function(values) {
                          return _vm.updateFilter(activeFilter, values)
                        },
                        removeFilter: function($event) {
                          return _vm.removeActiveFilter(activeFilter)
                        }
                      }
                    })
                  : _vm._e()
              ]
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }